import { isNodeSelection, isTextSelection } from '@tiptap/core';
const DEFAULT_HIDDEN_NODE_NAMES = ['image', 'imageResize'];
export const createShouldShowBubbleMenu = ({ hiddenNodeNames = DEFAULT_HIDDEN_NODE_NAMES, } = {}) => {
    const hiddenNodes = new Set(hiddenNodeNames);
    return ({ editor, element, state, view, from, to }) => {
        if (!editor?.isEditable) {
            return false;
        }
        const { selection, doc } = state;
        const isChildOfMenu = element?.contains(document.activeElement) ?? false;
        const hasEditorFocus = view.hasFocus() || isChildOfMenu;
        if (!hasEditorFocus) {
            return false;
        }
        const nodeSelection = isNodeSelection(selection) ? selection : null;
        const nodeName = nodeSelection?.node?.type?.name;
        if (nodeName && hiddenNodes.has(nodeName)) {
            return false;
        }
        // hide the bubble menu when there's no active text selection and focus isn’t within the menu
        if (selection.empty && !isChildOfMenu) {
            return false;
        }
        const isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(selection);
        if (isEmptyTextBlock && !isChildOfMenu) {
            return false;
        }
        return true;
    };
};
export const bubbleMenuShouldShow = createShouldShowBubbleMenu();
export const bubbleMenuMouseDownHandler = (event) => {
    const target = event.target;
    if (!target) {
        return;
    }
    const isButton = target.closest('button') !== null;
    if (!isButton) {
        event.preventDefault();
    }
};
